import { Link } from 'react-router-dom';
import { type PanelSpan } from '@/components/shared';
import type { BackofficeUserOrganization } from '../types';
import { UserDetailPanel } from './UserDetailPanelGrid';

export interface UserOrganizationsPanelProps {
  organizations: BackofficeUserOrganization[];
  panelId?: string | undefined;
  currentSpan?: PanelSpan | undefined;
}

function formatRole(role: BackofficeUserOrganization['role']): string {
  return role.charAt(0).toUpperCase() + role.slice(1);
}

export function UserOrganizationsPanel({
  organizations,
  panelId,
  currentSpan,
}: UserOrganizationsPanelProps) {
  return (
    <UserDetailPanel
      title="Organizations"
      span="2x2"
      panelId={panelId}
      currentSpan={currentSpan}
      contentClassName="mt-2"
    >
      {organizations.length > 0 ? (
        <ul className="divide-y divide-neutral-100">
          {organizations.map((organization) => (
            <li key={organization.id}>
              <Link
                to={`/organizations/${organization.id}`}
                className="focus-ring -mx-2 flex items-center justify-between gap-4 rounded-md px-2 py-3 hover:bg-backoffice-50"
              >
                <span className="min-w-0 truncate font-medium text-neutral-900">
                  {organization.name}
                </span>
                <span className="shrink-0 rounded-full bg-neutral-100 px-2.5 py-1 text-small font-medium text-neutral-700">
                  {formatRole(organization.role)}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-body text-neutral-500">No organizations found</p>
      )}
    </UserDetailPanel>
  );
}
